import { Box } from '@mui/material';
import { PrimaryLinkButton } from 'apps/wrapper/src/components/shared/buttons/buttons.styles';
import { useEventBus } from 'apps/wrapper/src/hooks/use-event-bus';
import moment from 'moment';
import { FC, useState } from 'react';
import { useApptRequestsWidget } from '../../hooks/use-appt-requests-widget';
import { getProviderAndOperatoryStatus } from '../../utils/provider-and-operatory-status';
import { LabeledSection } from '../labeled-section/labeled-section';
import { AppointmentDetailsSectionSkeleton } from './appointment-details-section.skeleton';
import { AppointmentDate, AppointmentDateWrapper, AppointmentDetailsItem } from './appointment-details-section.styles';

export interface AppointmentDetailsSectionProps {
  title: string;
  appointmentId: number;
  startTime: string;
  providerName: string | undefined;
  operatoryName: string | undefined;
  isLoading: boolean;
  hideControls: boolean;
}

export const AppointmentDetailsSection: FC<AppointmentDetailsSectionProps> = (props) => {
  const { title, appointmentId, startTime, providerName, operatoryName, isLoading, hideControls } = props;
  const { publishToIframes } = useEventBus();
  const { goToCalendarApp } = useApptRequestsWidget();
  const [onPreviewing, setOnPreviewing] = useState(false);

  const handlePreviewClick = async () => {
    setOnPreviewing(true);
    await goToCalendarApp();

    setTimeout(() => {
      publishToIframes({
        messageType: 'appt-preview',
        data: {
          id: appointmentId
        }
      });
    }, 200);

    setTimeout(() => setOnPreviewing(false), 1000);
  };

  if (isLoading) return <AppointmentDetailsSectionSkeleton />;

  return (
    <LabeledSection label={title}>
      <AppointmentDetailsItem>
        <AppointmentDateWrapper>
          <AppointmentDate>{moment(startTime).format('MM/DD/YYYY [at] h:mm a')}</AppointmentDate>
        </AppointmentDateWrapper>
        <Box sx={{ marginTop: '5px' }}>{getProviderAndOperatoryStatus(operatoryName, providerName)}</Box>
        {!hideControls && (
          <PrimaryLinkButton
            variant="text"
            onClick={handlePreviewClick}
            loading={onPreviewing}
            sx={{ justifyContent: 'flex-start', marginTop: '10px', width: '124px' }}
            disableRipple
          >
            View Appointment
          </PrimaryLinkButton>
        )}
      </AppointmentDetailsItem>
    </LabeledSection>
  );
};
